<h1>Angular UI Scroll Adapter Demos</h1>
<p>
  <em>Adapter</em> is&nbsp;a&nbsp;special object to&nbsp;access and manipulate
  the Scroller. The API it&nbsp;provides is&nbsp; discussed on&nbsp;this page.
  In order to get access to the <em>Adapter</em> API, the
  <em>Datasource</em> has to be instantiated via operator <em>new</em>:
</p>
<pre>{{ datasourceSample }}</pre>
<p>
  For better typings it is recommended to provide also data item type argument:
</p>
<pre>{{ datasourceTypedSample }}</pre>
<p>
  The constructor argument is&nbsp;an&nbsp;object of&nbsp;<em>IDatasource</em>
  type which must include <em>get</em> method property and may include
  <em>settings</em> object property. The Scroller augments the result
  <em>Datasource</em> object with the <em>Adapter</em> object property during
  instantiating. So, after the <em>Datasource</em> object had been instantiated,
  we&nbsp;may access <em>this.datasource.adapter</em> property object with its
  API methods and properties.
</p>
<app-demo-init></app-demo-init>
<app-demo-package-info></app-demo-package-info>
<app-demo-is-loading></app-demo-is-loading>
<app-demo-is-loading-advanced></app-demo-is-loading-advanced>
<app-demo-items-count></app-demo-items-count>
<app-demo-buffer-info></app-demo-buffer-info>
<app-demo-bof-eof></app-demo-bof-eof>
<app-demo-first-last-visible-items></app-demo-first-last-visible-items>
<app-demo-adapter-return-value></app-demo-adapter-return-value>
<app-adapter-relax></app-adapter-relax>
<app-demo-reload></app-demo-reload>
<app-demo-reset></app-demo-reset>
<app-demo-pause-resume></app-demo-pause-resume>
<app-demo-check-size></app-demo-check-size>
<app-demo-clip></app-demo-clip>
<app-demo-append-prepend></app-demo-append-prepend>
<app-demo-append-prepend-sync></app-demo-append-prepend-sync>
<app-demo-insert></app-demo-insert>
<app-demo-remove></app-demo-remove>
<app-demo-replace></app-demo-replace>
<app-demo-update></app-demo-update>
